<div class="page">
  <div class="header-card">
    <div>
      <h1>Módulos Analíticos</h1>
      <p>Escolha o módulo pelo menu principal: Módulo Analítico > grupo > rotina.</p>
    </div>
  </div>


  <section class="module-panel painel-unico">
      <div class="module-card">
        <div class="module-card-header">
          <div class="module-main-icon">{{ moduloSelecionado.icone }}</div>
          <div>
            <h2>{{ moduloSelecionado.titulo }}</h2>
            <p>{{ moduloSelecionado.descricao }}</p>
          </div>
          <span class="status-badge" [class]="classeStatus(moduloSelecionado.status)">
            {{ moduloSelecionado.status }}
          </span>
        </div>

        <div class="cartao-credito" *ngIf="moduloSelecionado.codigo === 'BANC_CARTAO_CREDITO'; else acertoRescisorioTpl">
          <div class="upload-panel">
            <div>
              <h3>Importar planilha de cartão de crédito</h3>
              <p>Leitura da aba <strong>CARTÃO DE CRÉDITO - AJUSTADA</strong>, sem gravar dados no banco.</p>
            </div>

            <div class="upload-actions">
              <label class="file-box">
                <span>Selecionar Excel</span>
                <input type="file" accept=".xlsx,.xls" (change)="selecionarArquivoCartao($event)" />
              </label>

              <button type="button" class="btn-primary" (click)="analisarCartaoCredito()" [disabled]="carregandoCartao">
                {{ carregandoCartao ? 'Lendo...' : 'Ler planilha' }}
              </button>

              <button type="button" class="btn-light" (click)="baixarPlanilhaRetornoCartao()" [disabled]="!resultadoCartao?.aba_encontrada || baixandoRelatorioCartao">
                {{ baixandoRelatorioCartao ? 'Gerando...' : 'Baixar planilha de retorno' }}
              </button>

              <button type="button" class="btn-light" (click)="limparCartaoCredito()">Limpar</button>
            </div>
          </div>

          <div class="alert erro" *ngIf="erroCartao">{{ erroCartao }}</div>
          <div class="alert ok" *ngIf="mensagemCartao">{{ mensagemCartao }}</div>

          <div class="sheet-info" *ngIf="resultadoCartao">
            <div class="info-chip">
              <span>Aba lida</span>
              <strong>{{ resultadoCartao.aba_lida || 'Não encontrada' }}</strong>
            </div>
            <div class="info-chip">
              <span>Registros</span>
              <strong>{{ resultadoCartao.total_registros }}</strong>
            </div>
            <div class="info-chip">
              <span>Colunas</span>
              <strong>{{ resultadoCartao.colunas.length }}</strong>
            </div>
          </div>

          <div class="cartao-summary" *ngIf="resultadoCartao?.aba_encontrada && resultadoCartao?.resumo">
            <div class="summary-card">
              <span>Total das faturas</span>
              <strong>{{ formatarMoeda(resultadoCartao?.resumo?.total_faturas || 0) }}</strong>
            </div>

            <div class="summary-card">
              <span>Total pago</span>
              <strong>{{ formatarMoeda(resultadoCartao?.resumo?.total_pago || 0) }}</strong>
            </div>

            <div class="summary-card">
              <span>Encargos cobrados</span>
              <strong>{{ formatarMoeda(resultadoCartao?.resumo?.total_encargos_cobrados || 0) }}</strong>
            </div>

            <div class="summary-card">
              <span>Encargos devidos</span>
              <strong>{{ formatarMoeda(resultadoCartao?.resumo?.total_encargos_devidos || 0) }}</strong>
            </div>

            <div class="summary-card destaque">
              <span>Diferença a compensar</span>
              <strong>{{ formatarMoeda(resultadoCartao?.resumo?.total_diferenca_compensar || 0) }}</strong>
            </div>

            <div class="summary-card">
              <span>Meses com abusividade</span>
              <strong>{{ resultadoCartao?.resumo?.meses_com_abusividade || 0 }}</strong>
            </div>
          </div>

          <div class="formula-box" *ngIf="resultadoCartao?.aba_encontrada && resultadoCartao?.resumo">
            <strong>Critério inicial de conferência:</strong>
            {{ resultadoCartao?.resumo?.criterio }}
          </div>

          <div class="planilha-retorno-info" *ngIf="resultadoCartao?.aba_encontrada">
            <strong>Retorno pericial:</strong>
            clique em <b>Baixar planilha de retorno</b> para gerar o arquivo com os dados originais, conferência, ajustes, memória linha por linha e totais.
          </div>

          <div class="missing-sheet" *ngIf="resultadoCartao && !resultadoCartao.aba_encontrada">
            <h3>Abas disponíveis na planilha</h3>
            <div class="sheet-list">
              <span *ngFor="let aba of resultadoCartao.abas_disponiveis">{{ aba }}</span>
            </div>
          </div>

          <div class="grid-card" *ngIf="resultadoCartao?.aba_encontrada && resultadoCartao?.linhas?.length">
            <div class="table-header">
              <h3>Prévia da planilha carregada</h3>
              <span>O detalhamento completo será gravado na planilha de retorno</span>
            </div>

            <div class="legend-columns">
              <span class="leg entrada">Entrada da fatura</span>
              <span class="leg conferencia">Conferência calculada</span>
              <span class="leg ajuste">Ajuste calculado</span>
            </div>

            <div class="excel-grid">
              <table>
                <thead>
                  <tr>
                    <th *ngFor="let coluna of resultadoCartao?.colunas"
                        [class.col-conferencia]="colunasConferenciaCartao().includes(coluna)"
                        [class.col-ajuste]="colunasAjusteCartao().includes(coluna)"
                        [class.col-descricao]="coluna === 'Descrição Técnica'">
                      {{ coluna }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let linha of linhasCartaoVisiveis()">
                    <td *ngFor="let coluna of resultadoCartao?.colunas"
                        [class.col-conferencia]="colunasConferenciaCartao().includes(coluna)"
                        [class.col-ajuste]="colunasAjusteCartao().includes(coluna)"
                        [class.col-descricao]="coluna === 'Descrição Técnica'">
                      {{ valorCelulaCartao(linha, coluna) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="empty-upload" *ngIf="!resultadoCartao && !carregandoCartao">
            <h3>Como usar</h3>
            <p>Escolha a planilha Excel da perícia bancária e clique em <strong>Ler planilha</strong>. Nesta versão, o sistema apenas carrega e exibe os dados para conferência.</p>
          </div>
        </div>



        <ng-template #acertoRescisorioTpl>
        <div class="trabalhista-demo acerto-demo" *ngIf="moduloSelecionado.codigo === 'TRAB_ACERTO_RESCISORIO'; else trabalhistaVerbasTpl">
          <div class="analytic-hero acerto-hero">
            <div>
              <span class="eyebrow">v93.3 demonstrativo</span>
              <h3>Acerto Rescisório — saída KNIME/Python</h3>
              <p>Organização das três saídas: detalhe mensal, memória de cálculo em formato longo e resumo final por funcionário.</p>
            </div>
            <div class="hero-actions">
              <button type="button" class="btn-primary" (click)="gerarAcertoRescisorioDemo()">Gerar saídas</button>
              <button type="button" class="btn-light" (click)="exportarAcertoRescisorioDemo()" [disabled]="!acertoResumoFinal.length">Exportar CSV</button>
              <button type="button" class="btn-light" (click)="limparAcertoRescisorioDemo()">Limpar</button>
            </div>
          </div>

          <div class="acerto-flow-box">
            <div class="flow-step"><strong>output_table_1</strong><span>df detalhado mensal</span></div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><strong>output_table_2</strong><span>memoria_long</span></div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><strong>output_table_3</strong><span>resumo final</span></div>
          </div>

          <div class="acerto-tabs">
            <button type="button" [class.ativa]="acertoAbaAtiva === 'resumo'" (click)="acertoAbaAtiva = 'resumo'">Resumo final</button>
            <button type="button" [class.ativa]="acertoAbaAtiva === 'memoria'" (click)="acertoAbaAtiva = 'memoria'">Memória longa</button>
            <button type="button" [class.ativa]="acertoAbaAtiva === 'detalhe'" (click)="acertoAbaAtiva = 'detalhe'">Detalhe mensal</button>
            <button type="button" [class.ativa]="acertoAbaAtiva === 'achados'" (click)="acertoAbaAtiva = 'achados'">Achados</button>
          </div>

          <div class="financing-results" *ngIf="acertoResumoFinal.length">
            <div class="result-card destaque"><span>Total bruto</span><strong>{{ formatarMoeda(acertoResumoFinal[0].vr_total_bruto_rescisao) }}</strong></div>
            <div class="result-card"><span>Descontos</span><strong>{{ formatarMoeda(acertoResumoFinal[0].vr_total_descontos_rescisao) }}</strong></div>
            <div class="result-card trabalhista-total"><span>Total líquido</span><strong>{{ formatarMoeda(acertoResumoFinal[0].vr_total_liquido_rescisao) }}</strong></div>
            <div class="result-card"><span>Total FGTS</span><strong>{{ formatarMoeda(acertoResumoFinal[0].total_fgts) }}</strong></div>
          </div>

          <div class="amortizacao-table financing-table acerto-table" *ngIf="acertoAbaAtiva === 'resumo' && acertoResumoFinal.length">
            <div class="table-header"><h3>output_table_3 — resumo final</h3><span>agrupado por id_funcionario e nome</span></div>
            <div class="table-scroll"><table><thead><tr><th>ID</th><th>Nome</th><th>Dias aviso</th><th>13º c/ projeção</th><th>Férias c/ projeção</th><th>HE 50</th><th>HE 100</th><th>DSR HE</th><th>FGTS</th><th>Bruto</th><th>Descontos</th><th>Líquido</th></tr></thead><tbody><tr *ngFor="let r of acertoResumoFinal"><td>{{ r.id_funcionario }}</td><td>{{ r.nome }}</td><td>{{ r.dias_aviso }}</td><td>{{ r.avos_13o_com_projecao }}</td><td>{{ r.avos_ferias_com_projecao }}</td><td>{{ formatarMoeda(r.hora_extra_50) }}</td><td>{{ formatarMoeda(r.hora_extra_100) }}</td><td>{{ formatarMoeda(r.dsr_sobre_he) }}</td><td>{{ formatarMoeda(r.total_fgts) }}</td><td>{{ formatarMoeda(r.vr_total_bruto_rescisao) }}</td><td>{{ formatarMoeda(r.vr_total_descontos_rescisao) }}</td><td>{{ formatarMoeda(r.vr_total_liquido_rescisao) }}</td></tr></tbody></table></div>
          </div>

          <div class="amortizacao-table financing-table acerto-table" *ngIf="acertoAbaAtiva === 'memoria' && acertoMemoriaLong.length">
            <div class="table-header"><h3>output_table_2 — memória long</h3><span>verba, valor, fator e valor corrigido</span></div>
            <div class="table-scroll"><table><thead><tr><th>ID</th><th>Nome</th><th>Competência</th><th>Verba</th><th>Valor</th><th>Fator</th><th>Valor corrigido</th></tr></thead><tbody><tr *ngFor="let m of acertoMemoriaLong"><td>{{ m.id_funcionario }}</td><td>{{ m.nome }}</td><td>{{ m.competencia }}</td><td>{{ m.verba }}</td><td>{{ formatarMoeda(m.valor) }}</td><td>{{ formatarNumero(m.fator_correcao, 4) }}</td><td>{{ formatarMoeda(m.valor_corrigido) }}</td></tr></tbody></table></div>
          </div>

          <div class="amortizacao-table financing-table acerto-table" *ngIf="acertoAbaAtiva === 'detalhe' && acertoDetalheMensal.length">
            <div class="table-header"><h3>output_table_1 — detalhe mensal</h3><span>base calculada por competência/evento</span></div>
            <div class="table-scroll"><table><thead><tr><th>ID</th><th>Nome</th><th>Competência</th><th>Evento</th><th>Salário</th><th>HE 50</th><th>HE 100</th><th>DSR HE</th><th>FGTS mensal</th><th>Líquido rescisão</th></tr></thead><tbody><tr *ngFor="let d of acertoDetalheMensal"><td>{{ d.id_funcionario }}</td><td>{{ d.nome }}</td><td>{{ d.competencia }}</td><td>{{ d.tipo_evento }}</td><td>{{ formatarMoeda(d.salario_base) }}</td><td>{{ formatarMoeda(d.hora_extra_50) }}</td><td>{{ formatarMoeda(d.hora_extra_100) }}</td><td>{{ formatarMoeda(d.dsr_sobre_he) }}</td><td>{{ formatarMoeda(d.fgts_mensal) }}</td><td>{{ formatarMoeda(d.vr_total_liquido_rescisao) }}</td></tr></tbody></table></div>
          </div>

          <div class="achados-demo" *ngIf="acertoAbaAtiva === 'achados' && acertoAchados.length">
            <div class="table-header"><h3>Achados automáticos demonstrativos</h3><span>orientados às saídas KNIME</span></div>
            <div class="achado-item" *ngFor="let achado of acertoAchados">{{ achado }}</div>
          </div>
        </div>
        </ng-template>

        <ng-template #trabalhistaVerbasTpl>
        <div class="trabalhista-demo verbas-demo" *ngIf="moduloSelecionado.codigo === 'TRAB_VERBAS'; else trabalhistaHorasTpl">
          <div class="analytic-hero trabalhista-hero">
            <div>
              <span class="eyebrow">v93.2 demonstrativo</span>
              <h3>Verbas Trabalhistas</h3>
              <p>Apuração demonstrativa de rescisão, saldo de salário, aviso, férias, 13º, FGTS e multa.</p>
            </div>
            <div class="hero-actions">
              <button type="button" class="btn-primary" (click)="calcularVerbasTrabalhistas()">Calcular verbas</button>
              <button type="button" class="btn-light" (click)="limparVerbasTrabalhistas()">Limpar</button>
            </div>
          </div>

          <div class="calc-section">
            <h3>Dados do vínculo e rescisão</h3>
            <div class="calc-grid financing-grid">
              <label><span>Salário base</span><input type="number" step="0.01" [(ngModel)]="verbasForm.salarioBase" /></label>
              <label><span>Admissão</span><input type="date" [(ngModel)]="verbasForm.dataAdmissao" /></label>
              <label><span>Demissão</span><input type="date" [(ngModel)]="verbasForm.dataDemissao" /></label>
              <label>
                <span>Tipo de rescisão</span>
                <select [(ngModel)]="verbasForm.tipoRescisao">
                  <option value="SEM_JUSTA_CAUSA">Sem justa causa</option>
                  <option value="PEDIDO_DEMISSAO">Pedido de demissão</option>
                  <option value="JUSTA_CAUSA">Justa causa</option>
                  <option value="ACORDO">Acordo</option>
                </select>
              </label>
              <label><span>Dias saldo salário</span><input type="number" step="1" [(ngModel)]="verbasForm.diasSaldoSalario" /></label>
              <label><span>Aviso prévio dias</span><input type="number" step="1" [(ngModel)]="verbasForm.avisoPrevioDias" /></label>
              <label><span>Férias proporcionais avos</span><input type="number" step="1" [(ngModel)]="verbasForm.feriasProporcionaisAvos" /></label>
              <label><span>13º proporcional avos</span><input type="number" step="1" [(ngModel)]="verbasForm.decimoTerceiroAvos" /></label>
              <label><span>FGTS informado</span><input type="number" step="0.01" [(ngModel)]="verbasForm.fgtsSaldoInformado" /></label>
              <label class="check-line"><input type="checkbox" [(ngModel)]="verbasForm.feriasVencidas" /><span>Há férias vencidas</span></label>
              <label class="check-line"><input type="checkbox" [(ngModel)]="verbasForm.considerarMultaFgts" /><span>Considerar multa FGTS 40%</span></label>
            </div>
          </div>

          <div class="financing-results" *ngIf="verbasResultado">
            <div class="result-card destaque"><span>Saldo salário</span><strong>{{ formatarMoeda(verbasResultado.saldoSalario) }}</strong></div>
            <div class="result-card"><span>Aviso prévio</span><strong>{{ formatarMoeda(verbasResultado.avisoPrevio) }}</strong></div>
            <div class="result-card"><span>13º proporcional</span><strong>{{ formatarMoeda(verbasResultado.decimoTerceiro) }}</strong></div>
            <div class="result-card"><span>Férias + 1/3</span><strong>{{ formatarMoeda(verbasResultado.feriasVencidasValor + verbasResultado.feriasProporcionais + verbasResultado.tercoFerias) }}</strong></div>
            <div class="result-card"><span>FGTS estimado</span><strong>{{ formatarMoeda(verbasResultado.fgtsEstimado) }}</strong></div>
            <div class="result-card trabalhista-alerta"><span>Multa FGTS</span><strong>{{ formatarMoeda(verbasResultado.multaFgts) }}</strong></div>
            <div class="result-card destaque"><span>Total bruto</span><strong>{{ formatarMoeda(verbasResultado.totalBruto) }}</strong></div>
            <div class="result-card trabalhista-total"><span>Total com FGTS</span><strong>{{ formatarMoeda(verbasResultado.totalComFgts) }}</strong></div>
          </div>

          <div class="achados-demo" *ngIf="verbasResultado">
            <div class="table-header"><h3>Achados automáticos demonstrativos</h3><span>não grava no banco nesta versão</span></div>
            <div class="achado-item" *ngFor="let achado of verbasResultado.achados">{{ achado }}</div>
          </div>

          <div class="technical-summary" *ngIf="verbasResultado">
            <h3>Texto de apoio ao laudo</h3>
            <p>{{ verbasResultado.resumo }}</p>
          </div>
        </div>
        </ng-template>

        <ng-template #trabalhistaHorasTpl>
        <div class="trabalhista-demo horas-demo" *ngIf="moduloSelecionado.codigo === 'TRAB_HORAS'; else jurosBancariosTpl">
          <div class="analytic-hero trabalhista-hero horas-hero">
            <div>
              <span class="eyebrow">v93.2 demonstrativo</span>
              <h3>Horas Extras</h3>
              <p>Apuração demonstrativa de hora normal, horas 50%/100%, DSR, adicional noturno e reflexos.</p>
            </div>
            <div class="hero-actions">
              <button type="button" class="btn-primary" (click)="calcularHorasExtras()">Calcular horas</button>
              <button type="button" class="btn-light" (click)="limparHorasExtras()">Limpar</button>
            </div>
          </div>

          <div class="calc-section">
            <h3>Parâmetros de jornada</h3>
            <div class="calc-grid financing-grid">
              <label><span>Salário base</span><input type="number" step="0.01" [(ngModel)]="horasForm.salarioBase" /></label>
              <label><span>Jornada mensal</span><input type="number" step="1" [(ngModel)]="horasForm.jornadaMensal" /></label>
              <label><span>Horas extras 50%</span><input type="number" step="0.01" [(ngModel)]="horasForm.horas50" /></label>
              <label><span>Horas extras 100%</span><input type="number" step="0.01" [(ngModel)]="horasForm.horas100" /></label>
              <label><span>Horas adicional noturno</span><input type="number" step="0.01" [(ngModel)]="horasForm.adicionalNoturnoHoras" /></label>
              <label><span>DSR (%)</span><input type="number" step="0.01" [(ngModel)]="horasForm.dsrPercentual" /></label>
              <label><span>Reflexos (%)</span><input type="number" step="0.01" [(ngModel)]="horasForm.reflexosPercentual" /></label>
            </div>
          </div>

          <div class="financing-results" *ngIf="horasResultado">
            <div class="result-card destaque"><span>Valor hora</span><strong>{{ formatarMoeda(horasResultado.valorHora) }}</strong></div>
            <div class="result-card"><span>Horas 50%</span><strong>{{ formatarMoeda(horasResultado.horas50Valor) }}</strong></div>
            <div class="result-card"><span>Horas 100%</span><strong>{{ formatarMoeda(horasResultado.horas100Valor) }}</strong></div>
            <div class="result-card"><span>Adic. noturno</span><strong>{{ formatarMoeda(horasResultado.adicionalNoturnoValor) }}</strong></div>
            <div class="result-card"><span>Total horas</span><strong>{{ formatarMoeda(horasResultado.totalHoras) }}</strong></div>
            <div class="result-card"><span>DSR</span><strong>{{ formatarMoeda(horasResultado.dsr) }}</strong></div>
            <div class="result-card"><span>Reflexos</span><strong>{{ formatarMoeda(horasResultado.reflexos) }}</strong></div>
            <div class="result-card trabalhista-total"><span>Total geral</span><strong>{{ formatarMoeda(horasResultado.totalGeral) }}</strong></div>
          </div>

          <div class="achados-demo" *ngIf="horasResultado">
            <div class="table-header"><h3>Achados automáticos demonstrativos</h3><span>não grava no banco nesta versão</span></div>
            <div class="achado-item" *ngFor="let achado of horasResultado.achados">{{ achado }}</div>
          </div>

          <div class="technical-summary" *ngIf="horasResultado">
            <h3>Texto de apoio ao laudo</h3>
            <p>{{ horasResultado.resumo }}</p>
          </div>
        </div>
        </ng-template>

        <ng-template #jurosBancariosTpl>
        
        <div class="juros-bancarios analise-financiamento consignado-demo" *ngIf="moduloSelecionado.codigo === 'BANC_CONSIGNADO'; else jurosAbusivosTpl">
          <div class="analytic-hero consignado-hero">
            <div>
              <span class="eyebrow">v93.1 demonstrativo</span>
              <h3>Crédito Consignado</h3>
              <p>Simulação de contrato consignado com carência, juros proporcionais, parcela recalculada e evolução do saldo.</p>
            </div>

            <div class="hero-actions">
              <button type="button" class="btn-light" (click)="preencherExemploConsignado()">Carregar exemplo</button>
              <button type="button" class="btn-primary" (click)="calcularConsignado()">Calcular consignado</button>
            </div>
          </div>

          <div class="calc-section">
            <h3>Dados do contrato consignado</h3>

            <div class="calc-grid financing-grid">
              <label>
                <span>Valor / capital liberado</span>
                <input type="number" step="0.01" [(ngModel)]="consignadoForm.valorCapital" />
              </label>

              <label>
                <span>Parcela contrato</span>
                <input type="number" step="0.01" [(ngModel)]="consignadoForm.valorParcela" />
              </label>

              <label>
                <span>Prazo</span>
                <input type="number" step="1" [(ngModel)]="consignadoForm.numeroParcelas" />
              </label>

              <label>
                <span>Taxa juros A.M. (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="consignadoForm.taxaMensal" />
              </label>

              <label>
                <span>Taxa juros A.A. informada (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="consignadoForm.taxaAnual" />
              </label>

              <label>
                <span>CET A.M. (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="consignadoForm.cetMensal" />
              </label>

              <label>
                <span>CET A.A. informado (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="consignadoForm.cetAnual" />
              </label>

              <label>
                <span>Sistema</span>
                <select [(ngModel)]="consignadoForm.sistema">
                  <option value="CONSIGNADO_PRICE">Consignado — Price</option>
                  <option value="CONSIGNADO_LINEAR">Consignado — linear</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </label>
            </div>
          </div>

          <div class="calc-section carencia-section">
            <h3>Juros de carência</h3>

            <div class="calc-grid financing-grid">
              <label>
                <span>Assinatura</span>
                <input type="date" [(ngModel)]="consignadoForm.dataAssinatura" />
              </label>

              <label>
                <span>Data base</span>
                <input type="date" [(ngModel)]="consignadoForm.dataBase" />
              </label>

              <label>
                <span>1ª parcela</span>
                <input type="date" [(ngModel)]="consignadoForm.dataPrimeiraParcela" />
              </label>

              <label>
                <span>Última parcela</span>
                <input type="date" [(ngModel)]="consignadoForm.dataUltimaParcela" />
              </label>

              <label>
                <span>Dias de carência</span>
                <input type="number" step="1" [(ngModel)]="consignadoForm.diasCarencia" />
              </label>

              <label>
                <span>Juros carência (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="consignadoForm.jurosCarenciaPercentual" />
              </label>
            </div>

            <div class="calc-actions">
              <button type="button" class="btn-primary" (click)="calcularConsignado()">Calcular</button>
              <button type="button" class="btn-light" (click)="exportarMemoriaConsignadoDemo()" [disabled]="!consignadoResultado">Exportar memória CSV</button>
              <button type="button" class="btn-light" (click)="limparConsignado()">Limpar</button>
            </div>
          </div>

          <div class="financing-results" *ngIf="consignadoResultado">
            <div class="result-card destaque">
              <span>Capital liberado</span>
              <strong>{{ formatarMoeda(consignadoResultado.valorCapital) }}</strong>
            </div>

            <div class="result-card carencia">
              <span>Juros de carência</span>
              <strong>{{ formatarMoeda(consignadoResultado.jurosCarencia) }}</strong>
            </div>

            <div class="result-card">
              <span>Saldo após carência</span>
              <strong>{{ formatarMoeda(consignadoResultado.saldoPosCarencia) }}</strong>
            </div>

            <div class="result-card destaque">
              <span>Parcela contrato</span>
              <strong>{{ formatarMoeda(consignadoResultado.parcelaContrato) }}</strong>
            </div>

            <div class="result-card destaque">
              <span>Parcela recalculada</span>
              <strong>{{ formatarMoeda(consignadoResultado.parcelaRecalculada) }}</strong>
            </div>

            <div class="result-card diferenca" [class.negativo]="consignadoResultado.diferencaMensal < 0">
              <span>Diferença mensal</span>
              <strong>{{ formatarMoeda(consignadoResultado.diferencaMensal) }}</strong>
            </div>

            <div class="result-card">
              <span>Diferença total</span>
              <strong>{{ formatarMoeda(consignadoResultado.diferencaTotal) }}</strong>
            </div>

            <div class="result-card">
              <span>CET anual equivalente</span>
              <strong>{{ formatarPercentual(consignadoResultado.cetAnualEfetiva) }}</strong>
            </div>
          </div>

          <div class="achados-demo" *ngIf="consignadoResultado">
            <div class="table-header">
              <h3>Achados automáticos demonstrativos</h3>
              <span>não grava no banco nesta versão</span>
            </div>

            <div class="achado-item" *ngFor="let achado of consignadoResultado.achados">
              {{ achado }}
            </div>
          </div>

          <div class="amortizacao-table financing-table" *ngIf="consignadoResultado">
            <div class="table-header">
              <h3>Memória de cálculo — consignado</h3>
              <span>{{ consignadoResultado.parcelas.length }} parcela(s)</span>
            </div>

            <div class="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Parc.</th>
                    <th>Saldo inicial</th>
                    <th>Juros</th>
                    <th>Amortização</th>
                    <th>Parcela recalculada</th>
                    <th>Saldo final</th>
                    <th>Fator</th>
                    <th>Diferença</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let parcela of consignadoResultado.parcelas">
                    <td>{{ parcela.numero }}</td>
                    <td>{{ formatarMoeda(parcela.saldoInicial) }}</td>
                    <td>{{ formatarMoeda(parcela.juros) }}</td>
                    <td>{{ formatarMoeda(parcela.amortizacao) }}</td>
                    <td>{{ formatarMoeda(parcela.parcela) }}</td>
                    <td>{{ formatarMoeda(parcela.saldoFinal) }}</td>
                    <td>{{ formatarNumero(parcela.fator, 5) }}</td>
                    <td>{{ formatarMoeda(parcela.diferencaParcela) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="technical-summary" *ngIf="consignadoResultado">
            <h3>Texto de apoio ao laudo</h3>
            <p>{{ consignadoResultado.resumo }}</p>
          </div>
        </div>

        <ng-template #jurosAbusivosTpl>
          <div class="juros-bancarios analise-financiamento juros-abusivos-v2" *ngIf="moduloSelecionado.codigo === 'BANC_JUROS_ABUSIVOS'; else jurosBancariosPadraoTpl">
            <div class="analytic-hero juros-hero">
              <div>
                <span class="eyebrow">Perícia Bancária</span>
                <h3>Juros Abusivos / Revisão Contratual</h3>
                <p>
                  Comparação preliminar da evolução contratual com indicadores econômicos importados pelo sistema.
                </p>
              </div>

              <div class="hero-actions">
                <label class="exemplo-select-wrap">
                  <span>Exemplo de preenchimento</span>
                  <select class="select-exemplo-contrato"
                          (change)="aplicarExemploJurosAbusivos($any($event.target).value); $any($event.target).value = ''">
                    <option value="">Selecione um exemplo...</option>
                    <option value="VEICULO_CDC">Veículo / CDC</option>
                    <option value="CONSIGNADO">Crédito consignado</option>
                  </select>
                </label>
                <button type="button" class="btn-primary" (click)="calcularJurosAbusivos()" [disabled]="jurosAbusivosCalculando">
                  {{ jurosAbusivosCalculando ? 'Calculando...' : 'Calcular análise' }}
                </button>
              </div>
            </div>

            
            <div class="contrato-formulario-pericial">

              <div class="explicacao-leigo intro-contrato">
                <strong>Como preencher:</strong>
                <p>
                  Esta análise segue a leitura natural de um contrato de financiamento de veículo:
                  primeiro identifica o contrato, depois confere o valor do bem, a entrada, os encargos
                  financiados, as taxas, o CET e a parcela. Em seguida, compara a taxa contratual com a
                  Taxa Média BCB da modalidade.
                </p>
              </div>

              <div class="calc-section contrato-bloco">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">1</span>
                    <h3>Identificação do contrato</h3>
                    <p>Informe a modalidade, período de contratação e prazo do financiamento.</p>
                  </div>
                </div>

                <div class="calc-grid financing-grid">
                  <label>
                    <span>Tipo de contrato</span>
                    <select [(ngModel)]="jurosAbusivosForm.tipoContrato" (ngModelChange)="aoAlterarTipoContrato()">
                      <option value="VEICULO_CDC">Veículo / CDC / Alienação fiduciária</option>
                      <option value="IMOBILIARIO">Imobiliário / SFH-SFI</option>
                      <option value="CONSIGNADO">Crédito consignado</option>
                      <option value="CARTAO">Cartão de crédito</option>
                      <option value="CHEQUE_ESPECIAL">Cheque especial</option>
                    </select>
                  </label>

                  <label>
                    <span>Data inicial do contrato</span>
                    <input type="date" [(ngModel)]="jurosAbusivosForm.dataInicial" />
                  </label>

                  <label>
                    <span>Data final / última parcela</span>
                    <input type="date" [(ngModel)]="jurosAbusivosForm.dataFinal" />
                  </label>

                  <label>
                    <span>Quantidade de parcelas</span>
                    <input type="number" step="1" [(ngModel)]="jurosAbusivosForm.qtdParcelas" />
                  </label>

                  <label>
                    <span>Modalidade BCB de referência</span>
                    <select disabled>
                      <option>Aquisição de veículos - Pessoa Física</option>
                    </select>
                    <small>Base técnica: BCB/SGS - séries 25471 mensal e 20749 anual.</small>
                  </label>
                </div>
              </div>

              <div class="tipo-contrato-info" [ngSwitch]="jurosAbusivosForm.tipoContrato">
                <div *ngSwitchCase="'VEICULO_CDC'" class="tipo-info-card ok">
                  <strong>Veículo / CDC / Alienação fiduciária</strong>
                  <p>
                    A análise usará a Taxa Média BCB da modalidade aquisição de veículos - pessoa física.
                    Informe valor do veículo, entrada, IOF, tarifa, gravame, seguro, prazo e parcela.
                  </p>
                </div>

                <div *ngSwitchCase="'IMOBILIARIO'" class="tipo-info-card pendente">
                  <strong>Imobiliário / SFH-SFI</strong>
                  <p>
                    Esta modalidade deve usar campos próprios: valor do imóvel, entrada, SAC/PRICE,
                    SFH/SFI, índice de correção, seguro MIP/DFI e taxa de administração.
                    A estrutura ficará nesta mesma página.
                  </p>
                </div>

                <div *ngSwitchCase="'CONSIGNADO'" class="tipo-info-card pendente">
                  <strong>Crédito consignado</strong>
                  <p>
                    Esta modalidade deve usar valor liberado, prazo, parcela, taxa mensal, CET,
                    convênio e comparação com a taxa média BCB de crédito consignado.
                  </p>
                </div>

                <div *ngSwitchCase="'CARTAO'" class="tipo-info-card pendente">
                  <strong>Cartão de crédito</strong>
                  <p>
                    Esta modalidade deve analisar rotativo, parcelamento, encargos, datas de fatura,
                    pagamentos e taxa média BCB própria da modalidade.
                  </p>
                </div>

                <div *ngSwitchCase="'CHEQUE_ESPECIAL'" class="tipo-info-card pendente">
                  <strong>Cheque especial</strong>
                  <p>
                    Esta modalidade deve analisar limite utilizado, dias de uso, taxa diária/mensal,
                    encargos e comparação com a taxa média BCB de cheque especial.
                  </p>
                </div>
              </div>

              <div class="calc-section contrato-bloco consignado-bloco" *ngIf="jurosAbusivosForm.tipoContrato === 'CONSIGNADO'">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">2</span>
                    <h3>Dados do crédito consignado</h3>
                    <p>Informe os dados do contrato de consignação, conforme o extrato/consulta da margem.</p>
                  </div>
                </div>

                <div class="calc-grid financing-grid">
                  <label>
                    <span>Subtipo do consignado</span>
                    <select [(ngModel)]="jurosAbusivosForm.subtipoConsignado">
                      <option value="CONSIGNADO_TOTAL_PF">Consignado total - Pessoa Física</option>
                      <option value="CONSIGNADO_INSS">INSS - próxima etapa</option>
                      <option value="CONSIGNADO_SERVIDOR">Servidor público - próxima etapa</option>
                      <option value="CONSIGNADO_PRIVADO">Trabalhador privado - próxima etapa</option>
                    </select>
                  </label>

                  <label>
                    <span>Valor financiado informado</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.valorOriginal" />
                  </label>

                  <label>
                    <span>Valor líquido liberado</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.valorLiberadoConsignado" />
                  </label>

                  <label>
                    <span>Quantidade de prestações</span>
                    <input type="number" step="1" [(ngModel)]="jurosAbusivosForm.qtdParcelas" />
                  </label>

                  <label>
                    <span>Valor da prestação</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.valorParcela" />
                  </label>

                  <label>
                    <span>Data inicial</span>
                    <input type="date" [(ngModel)]="jurosAbusivosForm.dataInicial" />
                  </label>

                  <label>
                    <span>Data final</span>
                    <input type="date" [(ngModel)]="jurosAbusivosForm.dataFinal" />
                  </label>

                  <label>
                    <span>Carência</span>
                    <input type="number" step="1" [(ngModel)]="jurosAbusivosForm.carenciaConsignado" />
                  </label>

                  <label>
                    <span>Parcelas pagas</span>
                    <input type="number" step="1" [(ngModel)]="jurosAbusivosForm.parcelasPagasConsignado" />
                  </label>

                  <label>
                    <span>CET mensal informado (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.cetMensalInformado" />
                  </label>

                  <label>
                    <span>CET anual informado (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.cetAnualInformado" />
                  </label>

                  <label>
                    <span>Taxa contratual ao mês (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.taxaContratoMes" />
                    <small>Use a taxa informada ou o CET mensal, conforme o documento disponível.</small>
                  </label>
                </div>

                <div class="quadro-planilha-resumo consignado-resumo">
                  <h4>Resumo do contrato consignado</h4>

                  <div class="linha-planilha">
                    <span>Valor líquido liberado</span>
                    <strong>{{ formatarMoeda(valorBaseConsignado()) }}</strong>
                  </div>

                  <div class="linha-planilha">
                    <span>Valor da prestação</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.valorParcela) }}</strong>
                  </div>

                  <div class="linha-planilha">
                    <span>Quantidade de prestações</span>
                    <strong>{{ jurosAbusivosForm.qtdParcelas }}</strong>
                  </div>

                  <div class="linha-planilha total">
                    <span>Total das prestações</span>
                    <strong>{{ formatarMoeda(valorTotalParcelasConsignado()) }}</strong>
                  </div>

                  <div class="linha-planilha subtotal">
                    <span>Juros/encargos totais aproximados</span>
                    <strong>{{ formatarMoeda(jurosTotaisAproximadosConsignado()) }}</strong>
                  </div>
                </div>
              </div>

              <div class="calc-section contrato-bloco consignado-bloco" *ngIf="jurosAbusivosForm.tipoContrato === 'CONSIGNADO'">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">3</span>
                    <h3>Referência BCB do crédito consignado</h3>
                    <p>
                      A referência principal do consignado é a taxa média BCB da modalidade crédito pessoal consignado total - pessoa física, na competência da contratação ou reserva do contrato.
                    </p>
                  </div>
                </div>

                <div class="calc-grid financing-grid">
                  <label>
                    <span>Competência BCB usada</span>
                    <input type="text" placeholder="08/2023" [(ngModel)]="jurosAbusivosForm.competenciaBcbConsignado" />
                  </label>
                  <div class="acoes-linha campo-largo">
                    <button type="button" class="btn-bcb-consignado" (click)="buscarTaxaBcbConsignado()">
                      Buscar taxa BCB da competência
                    </button>
                    <button type="button" class="btn-calcular-consignado" (click)="calcularAnaliseConsignadoJurosAbusivos()">
                      Calcular análise do consignado
                    </button>
                    <small *ngIf="jurosAbusivosForm.mensagemBcbConsignado">{{ jurosAbusivosForm.mensagemBcbConsignado }}</small>
                  </div>

                  <label>
                    <span>Taxa média BCB mensal (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.taxaMediaBcbConsignadoMensal" />
                  </label>

                  <label>
                    <span>Taxa média BCB anual (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.taxaMediaBcbConsignadoAnual" />
                  </label>

                  <label class="campo-largo">
                    <span>Fonte / observação</span>
                    <input type="text" [(ngModel)]="jurosAbusivosForm.fonteBcbConsignado" />
                  </label>

                <div class="consignado-subbloco referencia-secundaria-consignado">
                  <h4>Segunda referência de comparação</h4>
                  <p>
                    Use este bloco para comparar o contrato também com um teto normativo ou referência documental,
                    como teto CNPS/INSS, teto do convênio ou limite informado no contrato/regulamento.
                  </p>

                  <div class="form-grid">
                    <label>
                      <span>Tipo de segunda referência</span>
                      <select [(ngModel)]="jurosAbusivosForm.tipoReferenciaSecundariaConsignado">
                        <option value="TETO_CNPS_INSS">Teto CNPS/INSS</option>
                        <option value="TETO_CONVENIO_ORGAO">Teto do convênio/órgão</option>
                        <option value="REFERENCIA_DOCUMENTAL">Referência documental manual</option>
                        <option value="OUTRA">Outra referência</option>
                      </select>
                    </label>

                    <label>
                      <span>Competência da segunda referência</span>
                      <input type="text" [(ngModel)]="jurosAbusivosForm.competenciaReferenciaSecundariaConsignado" placeholder="Ex.: 07/2023" />
                    </label>

                    <label>
                      <span>Taxa mensal da segunda referência (%)</span>
                      <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.taxaReferenciaSecundariaConsignadoMensal" />
                    </label>

                    <label>
                      <span>Taxa anual equivalente da segunda referência (%)</span>
                      <input type="text" [value]="formatarNumero(taxaReferenciaSecundariaConsignadoAnualCalculada(), 2)" readonly />
                    </label>

                    <label class="campo-largo">
                      <span>Fonte da segunda referência</span>
                      <input type="text" [(ngModel)]="jurosAbusivosForm.fonteReferenciaSecundariaConsignado" />
                    </label>
                  </div>

                  <div class="consignado-resumo">
                    <div>
                      <span>Contrato / segunda referência</span>
                      <strong>{{ formatarNumero(contratoSobreReferenciaSecundariaConsignado(), 2) }}%</strong>
                    </div>
                    <div>
                      <span>Parcela pela segunda referência</span>
                      <strong>{{ formatarMoeda(parcelaReferenciaSecundariaConsignado()) }}</strong>
                    </div>
                    <div>
                      <span>Parcela / segunda referência</span>
                      <strong>{{ formatarNumero(parcelaSobreReferenciaSecundariaConsignado(), 2) }}%</strong>
                    </div>
                  </div>
                </div>

                </div>

                <div class="contrato-check-grid">
                  <div class="check-card">
                    <span>Taxa contratual mensal</span>
                    <strong>{{ formatarNumero(jurosAbusivosForm.taxaContratoMes, 2) }}%</strong>
                  </div>

                  <div class="check-card">
                    <span>Taxa média BCB mensal</span>
                    <strong>{{ formatarNumero(jurosAbusivosForm.taxaMediaBcbConsignadoMensal || 0, 2) }}%</strong>
                  </div>

                  <div class="check-card destaque">
                    <span>Contrato / Média BCB</span>
                    <strong>{{ formatarNumero(contratoSobreMediaBcbConsignado(), 2) }}%</strong>
                  </div>

                  <div class="check-card">
                    <span>Parcela pela média BCB</span>
                    <strong>{{ formatarMoeda(parcelaMediaBcbConsignado()) }}</strong>
                  </div>

                  <div class="check-card destaque">
                    <span>Parcela / Média BCB</span>
                    <strong>{{ formatarNumero(parcelaSobreMediaBcbConsignado(), 2) }}%</strong>
                  </div>
                </div>

                <div class="mensagem-conferencia" [ngClass]="classeConsignadoBcb()">
                  <strong>Leitura técnica inicial do consignado:</strong>
                  <p>{{ textoLeituraConsignadoCompleta() }}</p>
                </div>
              </div>

              <div class="calc-section contrato-bloco" *ngIf="jurosAbusivosForm.tipoContrato === 'VEICULO_CDC'">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">2</span>
                    <h3>Valor do bem e entrada</h3>
                    <p>Informe o valor do veículo, a entrada paga e o valor financiado constante no contrato.</p>
                  </div>
                </div>

                <div class="calc-grid financing-grid">
                  <label>
                    <span>Valor do veículo / bem</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.valorBem" />
                  </label>

                  <label>
                    <span>Entrada paga</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.entrada" />
                  </label>

                  <label>
                    <span>Valor financiado informado no contrato</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.valorOriginal" />
                    <small>Valor total financiado que aparece no contrato ou quadro-resumo.</small>
                  </label>
                </div>

                <div class="contrato-check-grid">
                  <div class="check-card">
                    <span>Valor líquido antes dos encargos</span>
                    <strong>{{ formatarMoeda(valorLiquidoFinanciadoVeiculo()) }}</strong>
                    <small>Valor do veículo menos entrada.</small>
                  </div>

                  <div class="check-card">
                    <span>Valor financiado informado</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.valorOriginal) }}</strong>
                    <small>Valor informado no contrato.</small>
                  </div>
                </div>
              </div>

              <div class="calc-section contrato-bloco composicao-veiculo" *ngIf="jurosAbusivosForm.tipoContrato === 'VEICULO_CDC'">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">3</span>
                    <h3>Encargos incluídos no financiamento</h3>
                    <p>Informe os valores somados ao saldo financiado, como IOF, tarifas, seguro e gravame.</p>
                  </div>

                  <button type="button" class="btn-light" (click)="usarValorRecalculadoComoBase()">
                    Usar valor financiado recalculado na análise
                  </button>
                </div>

                <div class="calc-grid financing-grid">
                  <label>
                    <span>IOF</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.iof" />
                    <small>Imposto sobre Operações Financeiras.</small>
                  </label>

                  <label>
                    <span>Tarifa de cadastro</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.tarifaCadastro" />
                  </label>

                  <label>
                    <span>Registro / gravame</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.registroGravame" />
                    <small>Registro da garantia/alienação fiduciária do veículo.</small>
                  </label>

                  <label>
                    <span>Seguro prestamista</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.seguroPrestamista" />
                  </label>

                  <label>
                    <span>Outras despesas financiadas</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.outrasDespesas" />
                  </label>
                </div>

                <div class="composicao-resumo-planilha">
                  <h4>Resumo da composição</h4>

                  <div class="linha-composicao">
                    <span>Valor do veículo</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.valorBem) }}</strong>
                  </div>

                  <div class="linha-composicao negativo">
                    <span>(-) Entrada</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.entrada) }}</strong>
                  </div>

                  <div class="linha-composicao subtotal">
                    <span>(=) Valor líquido financiado</span>
                    <strong>{{ formatarMoeda(valorLiquidoFinanciadoVeiculo()) }}</strong>
                  </div>

                  <div class="linha-composicao">
                    <span>(+) IOF</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.iof) }}</strong>
                  </div>

                  <div class="linha-composicao">
                    <span>(+) Tarifa de cadastro</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.tarifaCadastro) }}</strong>
                  </div>

                  <div class="linha-composicao">
                    <span>(+) Registro / gravame</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.registroGravame) }}</strong>
                  </div>

                  <div class="linha-composicao">
                    <span>(+) Seguro prestamista</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.seguroPrestamista) }}</strong>
                  </div>

                  <div class="linha-composicao">
                    <span>(+) Outras despesas</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.outrasDespesas) }}</strong>
                  </div>

                  <div class="linha-composicao total">
                    <span>(=) Valor financiado recalculado</span>
                    <strong>{{ formatarMoeda(valorFinanciadoVeiculoRecalculado()) }}</strong>
                  </div>
                </div>

                <div class="contrato-check-grid">
                  <div class="check-card">
                    <span>Valor financiado recalculado</span>
                    <strong>{{ formatarMoeda(valorFinanciadoVeiculoRecalculado()) }}</strong>
                  </div>

                  <div class="check-card">
                    <span>Valor financiado informado</span>
                    <strong>{{ formatarMoeda(jurosAbusivosForm.valorOriginal) }}</strong>
                  </div>

                  <div class="check-card destaque">
                    <span>Diferença entre contrato e composição</span>
                    <strong>{{ formatarMoeda(diferencaComposicaoVeiculo()) }}</strong>
                    <small>Diferença entre o valor informado e o valor recalculado.</small>
                  </div>
                </div>
              </div>

              <div class="calc-section contrato-bloco" *ngIf="jurosAbusivosForm.tipoContrato === 'VEICULO_CDC'">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">4</span>
                    <h3>Taxas, CET e parcelas</h3>
                    <p>Informe as taxas, o CET e o valor da prestação constante no contrato.</p>
                  </div>
                </div>

                <div class="calc-grid financing-grid">
                  <label>
                    <span>Taxa contratual ao mês (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.taxaContratoMes" />
                  </label>

                  <label>
                    <span>Taxa anual informada (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.taxaAnualInformada" />
                  </label>

                  <label>
                    <span>CET mensal informado (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.cetMensalInformado" />
                  </label>

                  <label>
                    <span>CET anual informado (%)</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.cetAnualInformado" />
                  </label>

                  <label>
                    <span>Valor da parcela</span>
                    <input type="number" step="0.01" [(ngModel)]="jurosAbusivosForm.valorParcela" />
                  </label>

                  <label>
                    <span>Indicador econômico de apoio</span>
                    <select [(ngModel)]="jurosAbusivosForm.indicador">
                      <option value="SELIC_MENSAL">SELIC mensal</option>
                      <option value="IPCA">IPCA</option>
                      <option value="INPC">INPC</option>
                      <option value="IGP_M">IGP-M</option>
                      <option value="IGP_DI">IGP-DI</option>
                      <option value="IPCA_E">IPCA-E</option>
                      <option value="INCC">INCC</option>
                      <option value="POUPANCA">Poupança</option>
                    </select>
                    <small>Usado como apoio econômico, não como parâmetro principal.</small>
                  </label>

                  <label>
                    <span>Faixa de alerta sobre a média BCB (%)</span>
                    <input type="number" step="1" [(ngModel)]="jurosAbusivosForm.criterioAlerta" />
                    <small>Ex.: 150% indica alerta quando superar 1,5 vez a média BCB.</small>
                  </label>
                </div>
              </div>

              <div class="calc-section contrato-bloco" *ngIf="jurosAbusivosForm.tipoContrato === 'VEICULO_CDC'">
                <div class="contrato-bloco-header">
                  <div>
                    <span class="contrato-etapa">5</span>
                    <h3>Conferência automática do contrato</h3>
                    <p>Resumo técnico inicial antes do cálculo comparativo.</p>
                  </div>
                </div>

                <div class="contrato-check-grid">
                  <div class="check-card">
                    <span>Total das parcelas</span>
                    <strong>{{ formatarMoeda(valorTotalParcelasVeiculo()) }}</strong>
                    <small>Quantidade de parcelas × valor da parcela.</small>
                  </div>

                  <div class="check-card">
                    <span>Taxa anual equivalente calculada</span>
                    <strong>{{ formatarNumero(taxaAnualEquivalenteContrato(), 2) }}%</strong>
                    <small>{{ avaliacaoTaxaAnualInformada() }}</small>
                  </div>

                  <div class="check-card">
                    <span>CET anual equivalente calculado</span>
                    <strong>{{ formatarNumero(cetAnualEquivalenteContrato(), 2) }}%</strong>
                    <small>{{ avaliacaoCetInformado() }}</small>
                  </div>

                  <div class="check-card destaque">
                    <span>Diferença de composição</span>
                    <strong>{{ formatarMoeda(diferencaComposicaoVeiculo()) }}</strong>
                    <small>Contrato informado x composição recalculada.</small>
                  </div>
                </div>

                <div class="explicacao-leigo">
                  <strong>Leitura inicial:</strong>
                  <p>
                    Primeiro, o sistema confere se o valor financiado informado no contrato bate com a composição:
                    valor do veículo, entrada, IOF, tarifas, gravame, seguro e demais despesas.
                  </p>
                  <p>
                    Depois, confere se a taxa mensal, a taxa anual, o CET mensal e o CET anual estão coerentes.
                    Em seguida, a análise compara a taxa contratual com a Taxa Média BCB da modalidade.
                  </p>
                </div>
              </div>

            </div>

<div class="alert erro" *ngIf="jurosAbusivosErro">{{ jurosAbusivosErro }}</div>

            <div class="technical-summary" *ngIf="(!jurosAbusivosResultado) && isContratoVeiculo()">
              <h3>Resultado preliminar</h3>
              <p>
                Informe os dados do contrato para comparar a evolução pela taxa contratual
                com a evolução pelo indicador de referência. O resultado será tratado como
                <strong>indício técnico</strong>, não como conclusão jurídica automática.
              </p>
            </div>

            <div class="resultado-juros-card" *ngIf="jurosAbusivosResultado && jurosAbusivosForm.tipoContrato === 'VEICULO_CDC'">
              <div class="resultado-head">
                <div *ngIf="isContratoVeiculo()">
                  <h3>Resultado preliminar por indicador econômico</h3>
                  <p>
                    Este bloco compara a evolução do contrato com o indicador selecionado, como SELIC, IPCA ou INPC.
                    Para contratos bancários de veículo, a comparação principal deve ser vista no bloco
                    <strong>Taxa Média BCB</strong>.
                  </p>
                </div>

                <div class="resultado-badge" [class.ok]="classeAvaliacaoJurosAbusivos() === 'ok'" [class.alerta]="classeAvaliacaoJurosAbusivos() === 'alerta'">
                  {{ classeAvaliacaoJurosAbusivos() === 'alerta' ? '⚠️' : '✅' }}
                  {{ jurosAbusivosResultado.avaliacao }}
                </div>
              </div>

              <div class="resultado-kpis">
                <div class="kpi-box">
                  <span>Periodicidade</span>
                  <strong>{{ jurosAbusivosResultado.periodicidade }}</strong>
                </div>

                <div class="kpi-box">
                  <span>Indicador</span>
                  <strong>{{ jurosAbusivosForm.indicador }}</strong>
                </div>

                <div class="kpi-box">
                  <span>Valor pelo indicador</span>
                  <strong>{{ formatarMoeda(jurosAbusivosResultado.valorPeloIndicador) }}</strong>
                </div>

                <div class="kpi-box">
                  <span>Valor pelo contrato</span>
                  <strong>{{ formatarMoeda(jurosAbusivosResultado.valorPeloContrato) }}</strong>
                </div>

                <div class="kpi-box destaque">
                  <span>Diferença apurada</span>
                  <strong>{{ formatarMoeda(jurosAbusivosResultado.diferenca) }}</strong>
                </div>

                <div class="kpi-box">
                  <span>Contrato / Indicador</span>
                  <strong>{{ formatarNumero(jurosAbusivosResultado.percentualContratoSobreIndicador, 2) }}%</strong>
                </div>

                <div class="kpi-box" *ngIf="taxaBcbVeiculosReferencia">
                  <span>Valor pela Média BCB Veículos</span>
                  <strong>{{ formatarMoeda(valorPelaMediaBcbVeiculos()) }}</strong>
                </div>

                <div class="kpi-box destaque" *ngIf="taxaBcbVeiculosReferencia">
                  <span>Contrato / Média BCB</span>
                  <strong>{{ formatarNumero(percentualContratoSobreMediaBcbValor(), 2) }}%</strong>
                </div>

                <div class="kpi-box destaque" *ngIf="taxaBcbVeiculosReferencia">
                  <span>Diferença contrato x BCB</span>
                  <strong>{{ formatarMoeda(diferencaContratoMediaBcbVeiculos()) }}</strong>
                </div>
              </div>

              <div class="comparativo-visual">
                <h4>Comparativo visual</h4>

                <div class="barra-comparativo">
                  <div class="barra-label">Indicador</div>
                  <div class="barra-track">
                    <div class="barra-fill indicador" [style.width.%]="larguraBarraIndicador()"></div>
                  </div>
                  <div class="barra-valor">{{ formatarMoeda(jurosAbusivosResultado.valorPeloIndicador) }}</div>
                </div>

                <div class="barra-comparativo" *ngIf="taxaBcbVeiculosReferencia">
                  <div class="barra-label">Média BCB Veículos</div>
                  <div class="barra-track">
                    <div class="barra-fill bcb-veiculos" [style.width.%]="larguraBarraMediaBcbVeiculos()"></div>
                  </div>
                  <div class="barra-valor">{{ formatarMoeda(valorPelaMediaBcbVeiculos()) }}</div>
                </div>

                <div class="barra-comparativo">
                  <div class="barra-label">Contrato</div>
                  <div class="barra-track">
                    <div class="barra-fill contrato" [style.width.%]="larguraBarraContrato()"></div>
                  </div>
                  <div class="barra-valor">{{ formatarMoeda(jurosAbusivosResultado.valorPeloContrato) }}</div>
                </div>
              </div>

              <div class="parametros-tecnicos-card" *ngIf="taxaBcbVeiculosReferencia">
                <h4>Parâmetros técnicos de comparação</h4>

                <div class="parametros-grid">
                  <div class="parametro-item principal">
                    <span>1. Taxa média BCB da modalidade</span>
                    <strong>Parâmetro principal</strong>
                    <p>
                      Compara a taxa contratual com a taxa média de mercado divulgada pelo Banco Central
                      para aquisição de veículos - pessoa física, na competência do contrato.
                    </p>
                  </div>

                  <div class="parametro-item">
                    <span>2. CET e taxa anual equivalente</span>
                    <strong>Conferência de consistência</strong>
                    <p>
                      Verifica se taxa mensal, taxa anual, CET mensal e CET anual estão coerentes
                      em critério composto.
                    </p>
                  </div>

                  <div class="parametro-item">
                    <span>3. Parcela pela média BCB</span>
                    <strong>Faixa estimada de prestação</strong>
                    <p>
                      Estima a parcela pela média BCB e compara com a parcela contratada.
                    </p>
                  </div>

                  <div class="parametro-item">
                    <span>4. Valor pela média BCB</span>
                    <strong>Comparativo de evolução</strong>
                    <p>
                      Compara o valor final pelo contrato com o valor projetado pela média BCB.
                    </p>
                  </div>

                  <div class="parametro-item apoio">
                    <span>5. Indicador econômico</span>
                    <strong>Apoio secundário</strong>
                    <p>
                      SELIC, IPCA, INPC ou outro indicador ajudam na leitura econômica,
                      mas não substituem a taxa média BCB da modalidade.
                    </p>
                  </div>
                </div>

                <div class="resposta-quesito">
                  <h4>Síntese para resposta ao quesito</h4>
                  <p>{{ sinteseTecnicaHierarquia() }}</p>
                  <p><strong>{{ conclusaoTecnicaPericial() }}</strong></p>
                  <p class="nota-juridica">
                    A classificação é técnico-contábil. A qualificação jurídica da abusividade cabe ao Juízo,
                    considerando o contrato, a prova dos autos e o caso concreto.
                  </p>
                </div>
              </div>

              <div class="conclusao-perito">
                <div class="conclusao-head">
                  <h4>Conclusão técnica preliminar</h4>
                  <button type="button" class="btn-light" (click)="copiarConclusaoJurosAbusivos()">Copiar conclusão</button>
                </div>

                <textarea rows="5" [value]="textoConclusaoJurosAbusivos()" readonly></textarea>
              </div>
            </div>

            <div class="calc-section memoria-planilha" *ngIf="jurosAbusivosResultado && jurosAbusivosForm.tipoContrato === 'VEICULO_CDC'">
              <div class="secao-header">
                <div>
                  <h3>Memória de cálculo</h3>
                  <p>Demonstrativo técnico da evolução no período selecionado.</p>
                </div>

                <div class="hero-actions">
                  <div class="secao-resumo-mini">{{ jurosAbusivosResultado.linhas.length }} registro(s)</div>
                  <button type="button" class="btn-light" (click)="exportarMemoriaJurosAbusivosCsv()">Exportar CSV</button>
                </div>
              </div>

              <div class="table-wrap table-planilha">
                <table>
                  <thead>
                    <tr>
                      <th>Competência</th>
                      <th>Taxa indicador</th>
                      <th>Fator indicador</th>
                      <th>Valor pelo indicador</th>
                      <th>Valor pelo contrato</th>
                      <th>Diferença</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let linha of jurosAbusivosResultado.linhas">
                      <td>{{ linha.competencia | date:'dd/MM/yyyy':'UTC' }}</td>
                      <td class="num">{{ formatarNumero(linha.taxaIndicador, 4) }}%</td>
                      <td class="num">{{ formatarNumero(linha.fatorIndicador, 8) }}</td>
                      <td class="num">{{ formatarMoeda(linha.valorPeloIndicador) }}</td>
                      <td class="num">{{ formatarMoeda(linha.valorPeloContrato) }}</td>
                      <td class="num destaque-col">{{ formatarMoeda(linha.diferenca) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3"><strong>Resultado final</strong></td>
                      <td class="num"><strong>{{ formatarMoeda(jurosAbusivosResultado.valorPeloIndicador) }}</strong></td>
                      <td class="num"><strong>{{ formatarMoeda(jurosAbusivosResultado.valorPeloContrato) }}</strong></td>
                      <td class="num destaque-col"><strong>{{ formatarMoeda(jurosAbusivosResultado.diferenca) }}</strong></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </ng-template>


        <ng-template #jurosBancariosPadraoTpl>

        <div class="juros-bancarios analise-financiamento" *ngIf="moduloSelecionado.codigo === 'BANC_JUROS'; else moduloPadrao">
          <div class="analytic-hero">
            <div>
              <span class="eyebrow">v93.0 demonstrativo</span>
              <h3>Financiamento bancário / veículo</h3>
              <p>Simulação de fixa linear, conferência de CET, parcela contratual x recalculada e memória de cálculo.</p>
            </div>

            <div class="hero-actions">
              <button type="button" class="btn-light" (click)="preencherExemploFinanciamento()">Carregar exemplo</button>
              <button type="button" class="btn-primary" (click)="calcularJurosBancarios()">Calcular análise</button>
            </div>
          </div>

          <div class="calc-section">
            <h3>Resumo do contrato</h3>

            <div class="calc-grid financing-grid">
              <label>
                <span>Valor do veículo</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.valorVeiculo" />
              </label>

              <label>
                <span>Entrada</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.entrada" />
              </label>

              <label>
                <span>Valor do financiamento</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.valorFinanciamento" (input)="atualizarValorTotalFinanciado()" />
              </label>

              <label>
                <span>Valor IOF</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.valorIof" (input)="atualizarValorTotalFinanciado()" />
              </label>

              <label>
                <span>Valor total financiado</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.valorTotalFinanciado" />
              </label>

              <label>
                <span>Despesa de cartório</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.despesaCartorio" (input)="atualizarValorTotalFinanciado()" />
              </label>

              <label>
                <span>Despesa de gravame</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.despesaGravame" (input)="atualizarValorTotalFinanciado()" />
              </label>

              <label>
                <span>Comissão de originação</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.comissaoOrigem" (input)="atualizarValorTotalFinanciado()" />
              </label>

              <label>
                <span>Parcela do contrato</span>
                <input type="number" step="0.01" [(ngModel)]="jurosForm.valorParcela" />
              </label>

              <label>
                <span>Prazo</span>
                <input type="number" step="1" [(ngModel)]="jurosForm.numeroParcelas" />
              </label>
            </div>
          </div>

          <div class="calc-section">
            <h3>Taxas, CET e datas</h3>

            <div class="calc-grid financing-grid">
              <label>
                <span>Taxa juros A.M. (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="jurosForm.taxaMensal" />
              </label>

              <label>
                <span>Taxa juros A.A. informada (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="jurosForm.taxaAnual" />
              </label>

              <label>
                <span>CET A.M. (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="jurosForm.cetMensal" />
              </label>

              <label>
                <span>CET A.A. informado (%)</span>
                <input type="number" step="0.0001" [(ngModel)]="jurosForm.cetAnual" />
              </label>

              <label>
                <span>Sistema</span>
                <select [(ngModel)]="jurosForm.sistema">
                  <option value="FIXA_LINEAR">Fixa linear</option>
                  <option value="PRICE">Tabela Price</option>
                  <option value="SAC">SAC</option>
                  <option value="BULLET">Bullet</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </label>

              <label>
                <span>Assinatura</span>
                <input type="date" [(ngModel)]="jurosForm.dataAssinatura" />
              </label>

              <label>
                <span>1ª parcela</span>
                <input type="date" [(ngModel)]="jurosForm.dataPrimeiraParcela" />
              </label>

              <label>
                <span>Última parcela</span>
                <input type="date" [(ngModel)]="jurosForm.dataUltimaParcela" />
              </label>

              <label>
                <span>Data de vencimento</span>
                <input type="date" [(ngModel)]="jurosForm.dataVencimento" />
              </label>

              <label>
                <span>Data de pagamento</span>
                <input type="date" [(ngModel)]="jurosForm.dataPagamento" />
              </label>
            </div>

            <div class="calc-actions">
              <button type="button" class="btn-primary" (click)="calcularJurosBancarios()">Calcular</button>
              <button type="button" class="btn-light" (click)="exportarMemoriaBancariaDemo()" [disabled]="!jurosResultado">Exportar memória CSV</button>
              <button type="button" class="btn-light" (click)="limparJurosBancarios()">Limpar</button>
            </div>
          </div>

          <div class="financing-results" *ngIf="jurosResultado">
            <div class="result-card destaque">
              <span>Parcela contrato</span>
              <strong>{{ formatarMoeda(jurosResultado.parcelaContrato) }}</strong>
            </div>

            <div class="result-card destaque">
              <span>Parcela recalculada</span>
              <strong>{{ formatarMoeda(jurosResultado.parcelaRecalculada) }}</strong>
            </div>

            <div class="result-card diferenca" [class.negativo]="jurosResultado.diferencaMensal < 0">
              <span>Diferença mensal</span>
              <strong>{{ formatarMoeda(jurosResultado.diferencaMensal) }}</strong>
            </div>

            <div class="result-card">
              <span>Diferença total nominal</span>
              <strong>{{ formatarMoeda(jurosResultado.diferencaTotalNominal) }}</strong>
            </div>

            <div class="result-card">
              <span>Taxa anual efetiva</span>
              <strong>{{ formatarPercentual(jurosResultado.taxaAnualEfetiva) }}</strong>
            </div>

            <div class="result-card">
              <span>CET anual equivalente</span>
              <strong>{{ formatarPercentual(jurosResultado.cetAnualEfetiva) }}</strong>
            </div>

            <div class="result-card">
              <span>Total contrato</span>
              <strong>{{ formatarMoeda(jurosResultado.totalContrato) }}</strong>
            </div>

            <div class="result-card">
              <span>Total recalculado</span>
              <strong>{{ formatarMoeda(jurosResultado.totalRecalculado) }}</strong>
            </div>
          </div>

          <div class="achados-demo" *ngIf="jurosResultado">
            <div class="table-header">
              <h3>Achados automáticos demonstrativos</h3>
              <span>não grava no banco nesta versão</span>
            </div>

            <div class="achado-item" *ngFor="let achado of jurosResultado.achados">
              {{ achado }}
            </div>
          </div>

          <div class="amortizacao-table financing-table" *ngIf="jurosResultado">
            <div class="table-header">
              <h3>Memória de cálculo — evolução do saldo devedor</h3>
              <span>{{ jurosResultado.parcelas.length }} parcela(s)</span>
            </div>

            <div class="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Parc.</th>
                    <th>Saldo inicial</th>
                    <th>Fator JS</th>
                    <th>Juros %</th>
                    <th>Juros R$</th>
                    <th>Parcela contrato</th>
                    <th>Parcela recalculada</th>
                    <th>Amortização</th>
                    <th>Saldo final</th>
                    <th>JS^-1</th>
                    <th>Diferença</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let parcela of jurosResultado.parcelas">
                    <td>{{ parcela.numero }}</td>
                    <td>{{ formatarMoeda(parcela.saldoInicial) }}</td>
                    <td>{{ formatarNumero(parcela.fatorJs, 5) }}</td>
                    <td>{{ formatarNumero(parcela.jurosPercentual, 5) }}</td>
                    <td>{{ formatarMoeda(parcela.juros) }}</td>
                    <td>{{ formatarMoeda(parcela.parcelaContrato) }}</td>
                    <td>{{ formatarMoeda(parcela.parcelaRecalculada) }}</td>
                    <td>{{ formatarMoeda(parcela.amortizacao) }}</td>
                    <td>{{ formatarMoeda(parcela.saldoFinal) }}</td>
                    <td>{{ formatarNumero(parcela.jsInverso, 5) }}</td>
                    <td>{{ formatarMoeda(parcela.diferencaParcela) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="technical-summary" *ngIf="jurosResultado">
            <h3>Texto de apoio ao laudo</h3>
            <p>{{ jurosResultado.resumo }}</p>
          </div>
        </div>
        </ng-template>
        </ng-template>

        <ng-template #moduloPadrao>
          <div class="module-content-grid">
            <div class="info-box">
              <h3>Entrada de dados</h3>
              <p>Importação de planilhas, lançamento de valores, seleção da perícia e documentos de suporte.</p>
            </div>

            <div class="info-box">
              <h3>Processamento</h3>
              <p>Validação, cálculo, atualização, conferência e geração dos quadros analíticos.</p>
            </div>

            <div class="info-box wide">
              <h3>Resultado técnico</h3>
              <p>Resumo de critérios, memória de cálculo e informações preparadas para o laudo pericial.</p>
            </div>
          </div>
        </ng-template>
      </div>
    </section>
</div>
